/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import DisplayTextOnly from "cms/fields/layout/controls/display-text-only";
import { useCurrentDynamicField } from "cms/fields/dynamic-field";
import { FieldDisplayWrapper } from "cms/fields/layout/field-display-wrapper";
import { Fragment } from "react";
import { isArrayNotEmpty } from "utils/empty-exists";

const EmailFieldDisplay = () => {
    
    const { field } = useCurrentDynamicField();
    const { values } = field || {};

    return (
        <FieldDisplayWrapper>
            {isArrayNotEmpty(values) &&
                values.map((item, index) => {
                    const { value, settings } = item || {};
                    const { style, format } = settings || {};
                    const showAsLink = format === "field.email.mailto";
                    const showAsText = format === "field.email.text";
                    return (
                        <Fragment key={index}>
                            {showAsText && value &&
                            <DisplayTextOnly
                                value={value}
                                style={style}
                                className='email-bold'
                            />
                            }
                            {showAsLink && value &&
                            <a
                                href={`mailto:${value}`}
                                target='_blank'
                                rel='noreferrer'
                            >
                                <DisplayTextOnly
                                    value={value}
                                    style={style}
                                    className='email-link'
                                />
                            </a>
                            }
                        </Fragment>
                    );
                })}
        </FieldDisplayWrapper>
    );
};
EmailFieldDisplay.displayName = "EmailFieldDisplay";
export { EmailFieldDisplay };
